/**
 * How to let Claude follow the live checklist, shared by the old and the v2 checklist so both say the same.
 * The command starts the c2e-rollout skill in its follow mode (.claude/skills/c2e-rollout/SKILL.md).
 */
export const CLAUDE_FOLLOW_PROMPT = '/loop /c2e-rollout volg';

export const CLAUDE_FOLLOW_STEPS: string[] = [
    'Open Claude Code in de repo chargebee-exact, met de c2e-ops MCP aan (/mcp).',
    'Typ de opdracht hieronder. Log één keer in bij Auth0 als de browser opent.',
    'Claude leest de lijst elke paar minuten, doet de Claude-stappen en vinkt ze hier af. Handmatige stappen zet hij klaar; die vink jij af.',
    'Stoppen: typ "stop de loop" in Claude.',
];
